// Renders server-side validation failures next to the input the buyer has to
// correct. A field-scoped error shown in an alert() tells them something went
// wrong but not where, so they retry the same bad value — which is exactly what
// the checkout event log recorded before this existed.

const ERROR_CLASS = "text-custom-red text-xs font-medium mt-1";
const INVALID_INPUT_CLASS = "border-custom-red";

// The phone widget posts through a hidden input; the buyer types into the
// visible tel field beside it, so that is what must be marked and focused.
export function findFieldInput(root, field) {
  const posted = root.querySelector(`[name="profile[${field}]"]`);
  if (!posted) return null;

  const phoneWrapper = posted.closest("[data-phone-input]");
  return phoneWrapper?.querySelector('input[type="tel"]') || posted;
}

export function renderFieldError(input, message) {
  const anchor = input.closest("[data-phone-input]") || input;
  let slot = anchor.parentElement?.querySelector("[data-field-error]");

  if (!slot) {
    slot = document.createElement("p");
    slot.dataset.fieldError = "";
    slot.className = ERROR_CLASS;
    slot.setAttribute("role", "alert");
    anchor.insertAdjacentElement("afterend", slot);
  }

  slot.textContent = message;
  input.setAttribute("aria-invalid", "true");
  input.classList.add(INVALID_INPUT_CLASS);

  // Clear as soon as they start fixing it, so a stale message cannot outlive
  // the value that caused it.
  input.addEventListener(
    "input",
    () => {
      slot.remove();
      input.removeAttribute("aria-invalid");
      input.classList.remove(INVALID_INPUT_CLASS);
    },
    { once: true }
  );
}

// Returns false when nothing on the page maps to the reported fields, so the
// caller falls back to a general error rather than swallowing the failure.
export function showFieldErrors(root, errors) {
  if (!root || !errors || typeof errors !== "object" || Array.isArray(errors)) return false;

  let shown = false;

  Object.entries(errors).forEach(([field, message]) => {
    const input = findFieldInput(root, field);
    if (!input) return;

    renderFieldError(input, Array.isArray(message) ? message.join(", ") : message);

    if (!shown) {
      input.focus({ preventScroll: true });
      input.scrollIntoView?.({ behavior: "smooth", block: "center" });
    }
    shown = true;
  });

  return shown;
}
